import { Reducer } from "redux";

import { ValidatePatientInfoResponse } from "../models/Api/PatientInformation";
import { ValidatePatientInfoSubscriberIdDispatchType } from "../models/DispatchTypes/PatientInformation";
import { ValidatePatientSubscriberIdInfoActionDispatchTypes } from "../constants/PatientInformation";

export const initialState: ValidatePatientInfoResponse = {
  loading: false,
  response: false,
  error: null,
};

const ValidatePatientSubscriberIdInfo: Reducer<
  ValidatePatientInfoResponse,
  ValidatePatientInfoSubscriberIdDispatchType
> = (state = initialState, action) => {
  switch (action.type) {
    case ValidatePatientSubscriberIdInfoActionDispatchTypes.POST_VALIDATE_PATIENT_SUBSCRIBER_ID_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ValidatePatientSubscriberIdInfoActionDispatchTypes.POST_VALIDATE_PATIENT_SUBSCRIBER_ID_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
     case ValidatePatientSubscriberIdInfoActionDispatchTypes.POST_VALIDATE_PATIENT_SUBSCRIBER_ID_ERROR: {
      return {
        ...state,
        error: action.error,
        response: initialState.response,
        loading: false,
      };
    }
    case ValidatePatientSubscriberIdInfoActionDispatchTypes.POST_VALIDATE_PATIENT_SUBSCRIBER_ID_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ValidatePatientSubscriberIdInfo;
